export const headers = [
  { name: 'Agência', field: 'agency.name', sortable: true },
  { name: 'Prioridade', field: 'priority', sortable: true, custom: true },
  { name: 'Observações', field: 'observation', sortable: true },
  { name: 'Ações', field: 'actions', sortable: false }
]
